import type { TFunction } from 'i18next';

const PACKAGE_RESERVED_SPACE_PATTERN =
  /^PACKAGE_RESERVED_SPACE:\s*spaces reserved by packages:\s*(.*)$/;

export const translatePackageReservationError = (
  message: string,
  t: TFunction,
): string | undefined => {
  const match = PACKAGE_RESERVED_SPACE_PATTERN.exec(message.trim());
  if (!match) return undefined;

  const packages = match[1]?.trim();
  return packages
    ? t('package_reservation_errors.PACKAGE_RESERVED_SPACE', { packages })
    : t('package_reservation_errors.PACKAGE_RESERVED_SPACE_NO_NAME');
};
